
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

interface Song {
  id: number;
  title: string;
  artist: string;
  album: string;
  weeks: number;
  movement: 'up' | 'down' | 'same' | 'new';
}

interface SongCardProps {
  song: Song;
  position: number;
}

export default function SongCard({ song, position }: SongCardProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: song.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const getPositionColor = () => {
    if (position === 1) return 'bg-gradient-to-r from-yellow-400 to-yellow-600 text-white';
    if (position <= 3) return 'bg-gradient-to-r from-gray-300 to-gray-500 text-white';
    if (position <= 10) return 'bg-gradient-to-r from-orange-400 to-orange-600 text-white';
    return 'bg-gradient-to-r from-blue-500 to-blue-700 text-white';
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`bg-white/90 backdrop-blur-sm rounded-xl p-4 shadow-lg hover:shadow-xl transition-all duration-300 cursor-grab active:cursor-grabbing border border-white/20 ${
        isDragging ? 'opacity-50 scale-105' : ''
      }`}
    >
      <div className="flex items-center gap-4">
        <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg ${getPositionColor()}`}>
          {position}
        </div>
        
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-gray-900 truncate text-lg">{song.title}</h3>
          <p className="text-gray-600 truncate">{song.artist}</p>
        </div>
        
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-drag-move-2-line text-gray-400"></i>
        </div>
      </div>
    </div>
  );
}
